import React from "react";
import * as S from "./styled/index.styled";

const ButtonsTest = ({
  handleOnConfirmDrawerOutbound,
  handleOnConfirmDrawerInbound,
  handleOnConfirmDrawerViewRegister,
  handleOnConfirmDrawerInboundFromCheckin,
  handleOnConfirmFinishVehicle,
  OnConfirmCancelEdit,
}) => {
  return (
    <>
      <button data-testid="drawer-outbound" onClick={handleOnConfirmDrawerOutbound} style={S.FakeBtnConfirm} />
      <button data-testid="drawer-inbound" onClick={handleOnConfirmDrawerInbound} style={S.FakeBtnConfirm} />
      <button data-testid="drawer-edit" onClick={handleOnConfirmDrawerViewRegister} style={S.FakeBtnConfirm} />
      <button data-testid="drawer-edit-close" onClick={() => OnConfirmCancelEdit} style={S.FakeBtnConfirm} />
      <button data-testid="drawer-checkin" onClick={() => handleOnConfirmDrawerInboundFromCheckin} style={S.FakeBtnConfirm} />
      <button data-testid="finish-vehicle" onClick={() => handleOnConfirmFinishVehicle} style={S.FakeBtnConfirm} />
    </>
  );
};

export default ButtonsTest;
